function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, Heading, Text } from '@tempo/core';
export const LandingHeading = forwardRef((props, ref)=>{
    let variant;
    switch(props.as){
        case 'h1':
            variant = {
                base: 'heading.xl',
                md: 'display.l'
            };
            break;
        case 'h2':
            variant = {
                base: 'heading.l',
                md: 'display.s'
            };
            break;
        case 'h3':
            variant = {
                base: 'heading.s',
                md: 'heading.m'
            };
            break;
        default:
            variant = 'heading.s';
    }
    return /*#__PURE__*/ _jsx(Heading, _object_spread({
        maxW: "100ch",
        variant: variant,
        ref: ref
    }, props));
});
export const innerLinkTextStyle = {
    '& a': {
        color: 'text.accent.primary.default',
        _hover: {
            textDecoration: 'underline',
            color: 'text.accent.primary.hovered'
        }
    }
};
export const LandingParagraph = forwardRef((props, ref)=>{
    return /*#__PURE__*/ _jsx(Text, _object_spread({
        ref: ref,
        variant: "body.l.default",
        color: "text.neutral.secondary.default",
        width: "100%",
        maxW: "100ch",
        sx: innerLinkTextStyle
    }, props));
});

//# sourceMappingURL=LandingTypography.js.map